module.exports = __webpack_public_path__ + "static/sav_standalone_energy_monitor-dacee682bfde265479dcea34ac65e12f.png";